import { FatalErrorScreen } from '@app/core/error/FatalErrorScreen';
import { PropsWithChildren } from 'react';

/**
 * Returns true when `preview_fatal_error` is present and not an explicit off value
 * (`0` / `false`). Supports `?preview_fatal_error`, `?preview_fatal_error=1`, and `=true`.
 */
function isPreviewFatalErrorEnabled(): boolean {
  const value = new URLSearchParams(window.location.search).get('preview_fatal_error');
  if (value === null) {
    return false;
  }
  return value !== '0' && value.toLowerCase() !== 'false';
}

/**
 * Forces the fatal error screen when `?preview_fatal_error` is set, so it can be
 * reviewed without triggering a real ErrorBoundary.
 */
export function FatalErrorPreviewGate({ children }: PropsWithChildren<object>) {
  if (isPreviewFatalErrorEnabled()) {
    return <FatalErrorScreen />;
  }

  return <>{children}</>;
}
